var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.775,
    height: 16.775,
    viewBox: "0 0 16.775 16.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12434",
    "data-name": "Rectangle 12434",
    width: 8.3,
    height: 8.3,
    fill: "#fbfcfc",
    stroke: "#d9dee8",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14205",
    "data-name": "Group 14205",
    transform: "translate(-501.5 -215.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12429",
    "data-name": "Rectangle 12429",
    width: 16.775,
    height: 16.775,
    rx: 8.388,
    transform: "translate(501.5 215.5)",
    fill: "#0f968c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1267",
    "data-name": "Mask Group 1267",
    transform: "matrix(1, -0.017, 0.017, 1, 505.666, 219.811)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(0 0.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21153",
    "data-name": "Path 21153",
    d: "M3.178,6.32a.424.424,0,0,1-.6,0L.186,3.927a.635.635,0,0,1,0-.9l.3-.3a.635.635,0,0,1,.9,0L2.878,4.223,6.915.186a.635.635,0,0,1,.9,0l.3.3a.635.635,0,0,1,0,.9Z",
    transform: "translate(0 0)",
    fill: "#fbfcfc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success_tick.d48ab3ddbaf5d299717ea37b27d24095.svg";
export { ForwardRef as ReactComponent };